/** Prefix Task 3's list query keys under (`["conversations","query", body]`). */
export const CONVERSATIONS_QUERY_PREFIX = ["conversations", "query"] as const;
